/**
 *    DCC banner
 */

(function ($) {
  Drupal.behaviors.dccBanner = {
    attach(context, settings) {
      const $dccBanner = $('.vb-dcc-banner');
      if ($dccBanner.length) {
        setTimeout(() => {
          // observe
          new IntersectionObserver(((entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('vb--visible');
              }
            });
          }), {
            // root: document,
            rootMargin: '0px 0px 0px 0px',
            threshold: 0.5,
          }).observe($dccBanner[0]);
        }, 1000);
      }
    },
  };
}(jQuery));
// end of dcc-banner.js
